import styled from 'styled-components';

export const TemplateCellWrapper = styled.div`
  > button {
    text-align: left;
    padding: 0;
    margin: 0;
  }
`;
